import { useCallback, useEffect, useRef, useState } from 'react'
import { getTextSearch } from '../services/textSearches'

// Caches full TextSearch documents by id for the grid. Grid windows persist only
// `entityId`, so on reload we fetch any searches we don't already have. Callers
// can `seed` a search they already hold (e.g. from the sidebar or after a save)
// to skip the fetch, and `remove` one after deletion. Fetches are de-duped per
// id. Mirrors useGlobalChatCache.
export function useTextSearchCache(entityIds) {
  const [searchesById, setSearchesById] = useState({})
  const pendingRef = useRef(new Set())

  useEffect(() => {
    entityIds.forEach((id) => {
      if (!id || searchesById[id] || pendingRef.current.has(id)) return
      pendingRef.current.add(id)
      getTextSearch(id)
        .then((search) => search && setSearchesById((prev) => ({ ...prev, [id]: search })))
        .catch(() => {})
        .finally(() => pendingRef.current.delete(id))
    })
  }, [entityIds, searchesById])

  const seed = useCallback((search) => {
    if (search?._id) setSearchesById((prev) => ({ ...prev, [search._id]: search }))
  }, [])

  const remove = useCallback((id) => {
    setSearchesById((prev) => {
      if (!(id in prev)) return prev
      const next = { ...prev }
      delete next[id]
      return next
    })
  }, [])

  return { searchesById, seed, remove }
}
